export const useUrl = (): string => {
  if (typeof window !== "undefined" && window.location) {
    const { protocol, hostname, port } = window.location

    // If we're already on a PR preview, return current origin
    if (hostname.includes("deploy-preview")) {
      return `${protocol}//${hostname}`
    }

    return port
      ? `${protocol}//${hostname}:${port}`
      : `${protocol}//${hostname}`
  }

  // Handle build time - use Netlify's environment variables
  if (process.env.CONTEXT === "deploy-preview") {
    // Prefer DEPLOY_PRIME_URL as it gives the correct PR-based URL
    if (process.env.DEPLOY_PRIME_URL) {
      return process.env.DEPLOY_PRIME_URL.replace(/\/$/, "")
    }

    // Fallback: construct PR URL manually
    if (process.env.REVIEW_ID) {
      return `https://deploy-preview-${process.env.REVIEW_ID}--digitup-revamp-phase-1.netlify.app`
    }
  }

  // Fallback to SITE_URL or localhost
  const fallbackUrl = process.env.SITE_URL || "http://localhost:8000"
  return fallbackUrl.replace(/\/$/, "")
}
